import {Component, ChangeDetectionStrategy} from '@angular/core';
import {SeFeSpinnerModule} from 'se-fe-spinner';

@Component({
  selector: 'full-page-spinner',
  imports: [SeFeSpinnerModule],
  templateUrl: './full-page-spinner.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './full-page-spinner.component.scss',
})
export class FullPageSpinnerComponent {}
